import { BasicType } from "@easy-email-pro-core/constants";
import { ElementChildren, SocialElement } from "@easy-email-pro-core/typings";
import { BlockRenderer } from "../BlockRenderer";
import { isValidReactChildren } from "@easy-email-pro-core/utils/isValidReactChildren";
import React from "react";
import { RecursivePartial } from "@easy-email-pro-core/typings/helper";

export type SocialProps = RecursivePartial<SocialElement["attributes"]> & {
  idx?: string | null;
  children?: ElementChildren | SocialElement["children"];
  data?: SocialElement["data"];
};

export function Social(props: SocialProps) {
  const { data, idx, children: propsChildren, ...rest } = props;

  const node: SocialElement = {
    type: BasicType.SOCIAL,
    data: data || {},
    attributes: { ...rest },
    children: isValidReactChildren(propsChildren) ? [] : propsChildren || [],
  };

  return (
    <BlockRenderer
      idx={idx}
      node={node}
      children={isValidReactChildren(propsChildren) ? propsChildren : null}
    />
  );
}
